module.exports = __webpack_public_path__ + "dpb.jpg?d2b140087c046ffc77e4667bad7d3be5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/dpb.jpg
// module id = 112
// module chunks = 0